import { handleLoadTopPostsRequests } from "../scenes/LandingPage/sagas.js";
import { handleLoadPostBySlugRequests, handleLoadPostByIdRequests } from "../sagas/FeedSaga";
import { handleLoadCollectionRequests } from "../scenes/CollectionPage/sagas";
import { DEFAULT_COLLECTION_POSTS_COUNT } from "../actions/collectionActions";
import {
  handleLoadOpenedProfileInfoById,
  handleLoadOpenedProfileInfoByUsername,
  handleLoadMoreOpenedProfilePosts,
  handleLoadMoreOpenedProfileCollections,
  handleLoadMoreOpenedProfileFollowers,
  handleLoadMoreOpenedProfileFollowing,
} from "../scenes/OthersProfile/sagas";
import { handleSearchPostsRequests } from "../sagas/SearchSaga";

export function* HomeRouteSaga() {
  yield handleLoadTopPostsRequests();
}

export function* PostSlugRouteSaga(currentRoute) {
  yield handleLoadPostBySlugRequests({ slug: currentRoute.params.slug });
}

export function* PostIdRouteSaga(currentRoute) {
  yield handleLoadPostByIdRequests({ id: currentRoute.params.id });
}

export function* CollectionRouteSaga(currentRoute) {
  yield handleLoadCollectionRequests({ collectionId: currentRoute.params.id, limit: DEFAULT_COLLECTION_POSTS_COUNT });
}

export function* ProfileIdRouteSaga(currentRoute) {
  yield handleLoadOpenedProfileInfoById({ id: currentRoute.params.id });
  yield handleLoadMoreOpenedProfilePosts({ userId: currentRoute.params.id, limit: 5 });
}

export function* ProfileUsernameRouteSaga(currentRoute) {
  const user = yield handleLoadOpenedProfileInfoByUsername({ username: currentRoute.params.username });
  if (user) {
    yield handleLoadMoreOpenedProfilePosts({ userId: user.uid, limit: 5 });
  }
}

export function* ProfileIdCollectionsRouteSaga(currentRoute) {
  yield handleLoadOpenedProfileInfoById({ id: currentRoute.params.id });
  yield handleLoadMoreOpenedProfileCollections({ userId: currentRoute.params.id, limit: 10 });
}

export function* ProfileUsernameCollectionsRouteSaga(currentRoute) {
  const user = yield handleLoadOpenedProfileInfoByUsername({ username: currentRoute.params.username });
  if (user) {
    yield handleLoadMoreOpenedProfileCollections({ userId: user.uid, limit: 10 });
  }
}

export function* ProfileIdFollowersRouteSaga(currentRoute) {
  yield handleLoadOpenedProfileInfoById({ id: currentRoute.params.id });
  yield handleLoadMoreOpenedProfileFollowers({ userId: currentRoute.params.id, limit: 20 });
}

export function* ProfileUsernameFollowersRouteSaga(currentRoute) {
  const user = yield handleLoadOpenedProfileInfoByUsername({ username: currentRoute.params.username });
  if (user) {
    yield handleLoadMoreOpenedProfileFollowers({ userId: user.uid, limit: 20 });
  }
}

export function* ProfileIdFollowingRouteSaga(currentRoute) {
  yield handleLoadOpenedProfileInfoById({ id: currentRoute.params.id });
  yield handleLoadMoreOpenedProfileFollowing({ userId: currentRoute.params.id, limit: 20 });
}

export function* ProfileUsernameFollowingRouteSaga(currentRoute) {
  const user = yield handleLoadOpenedProfileInfoByUsername({ username: currentRoute.params.username });
  if (user) {
    yield handleLoadMoreOpenedProfileFollowing({ userId: user.uid, limit: 20 });
  }
}

export function* SearchRouteSaga(currentRoute) {
  yield handleSearchPostsRequests({ searchQuery: currentRoute.query.search_query, limit: 5 });
}



// WEBPACK FOOTER //
// ./src/sagas/server.js